import './App.css'
import Dashboard from './components/Dashbaord/Dashboard';
import Sidebar from './components/Sidebar/Sidebar';

function App() {
  return (
    <div className="App">
      <Sidebar/>
      <Dashboard/>
    </div>
  );
}

export default App;
